module.exports = __webpack_public_path__ + "static/media/vertical_dots.6d2e40ca.svg";